/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'version': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="#C4FFF9" fill-rule="evenodd"><path pid="0" d="M75 124.801c-27.461 0-49.801-22.344-49.801-49.801S47.539 25.199 75 25.199c27.461 0 49.801 22.34 49.801 49.801 0 27.461-22.344 49.801-49.801 49.801zm0-94.184c-24.477 0-44.383 19.906-44.383 44.383 0 24.477 19.906 44.379 44.383 44.379 24.477 0 44.383-19.906 44.383-44.379S99.473 30.617 75 30.617z"/><path pid="1" d="M60.527 63.73a2.681 2.681 0 0 1-1.914-.793 2.704 2.704 0 0 1 0-3.828l14.473-14.473a2.704 2.704 0 0 1 3.828 0l14.473 14.473a2.704 2.704 0 0 1 0 3.828 2.704 2.704 0 0 1-3.828 0l-12.56-12.555-12.554 12.551a2.704 2.704 0 0 1-1.918.797z"/><path pid="2" d="M75 106.152a2.706 2.706 0 0 1-2.707-2.707V50.121A2.706 2.706 0 0 1 75 47.414a2.706 2.706 0 0 1 2.707 2.707v53.32c0 1.5-1.21 2.71-2.707 2.71v.001z"/></g>'
  }
})
